import { createRoutableExtension } from '@backstage/core-plugin-api';
import { userSettingsPlugin } from '@backstage/plugin-user-settings';

/**
 * Make's BUI settings page, mounted on the user-settings plugin's route ref.
 *
 * The sidebar's Settings item (`Settings` from @backstage/plugin-user-settings)
 * builds its link from that route ref, so the page must be provided through
 * the plugin for `FlatRoutes` to discover the mount point, exactly as with
 * upstream's `UserSettingsPage`.
 */
export const MakeSettingsPage = userSettingsPlugin.provide(
  createRoutableExtension({
    name: 'MakeSettingsPage',
    component: () =>
      import('./SettingsPage').then(module => module.SettingsPage),
    mountPoint: userSettingsPlugin.routes.settingsPage,
  }),
);
